export default {
      id: "reports_raw-usage",
      viewBox: "0 0 35 40",
      url: __webpack_public_path__ + "img/icons.svg#reports_raw",
      toString: function () {
        return this.url;
      }
    }